var _style, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _defs, _g2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs2, _g3, _path17, _defs3, _g4, _path18, _path19, _path20, _defs4, _path21, _path22, _defs5, _g5, _path23, _path24, _defs6, _g6, _path25, _path26, _path27, _defs7, _g7, _path28, _path29, _path30, _path31, _path32, _g8, _path33, _defs8, _g9, _path34, _path35, _path36, _path37, _path38, _defs9, _g10, _path39, _defs10, _g11, _path40, _defs11, _g12, _path41, _path42;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRelaxingMan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1479.7 918.7",
    style: {
      enableBackground: "new 0 0 1479.7 918.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.118;fill:url(#background_1_);enable-background:new    ;}\n\t.st1{fill:url(#_3_1_);}\n\t.st2{fill:url(#_2_1_);}\n\t.st3{fill:url(#_1_1_);}\n\t.st4{opacity:0.2;}\n\t.st5{fill:#8CA4D4;}\n\t.st6{fill:#123584;}\n\t.st7{fill:url(#Shape_9-2_1_);}\n\t.st8{clip-path:url(#SVGID_2_);}\n\t.st9{fill:#A1B8E3;}\n\t\n\t\t.st10{opacity:0.5;fill:none;stroke:#8CA4D4;stroke-width:5;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:5,20;enable-background:new    ;}\n\t.st11{fill:url(#Shape_5_1_);}\n\t.st12{fill:#E1A846;}\n\t.st13{fill:#E6B052;}\n\t.st14{fill:url(#chair_shadow_1_);}\n\t.st15{fill:url(#chair_1_);}\n\t.st16{fill:url(#cushion_1_);}\n\t.st17{fill:#94B0D7;}\n\t.st18{fill:url(#Path_17-2_1_);}\n\t.st19{clip-path:url(#SVGID_4_);}\n\t.st20{opacity:0.2;fill:#3D82F0;enable-background:new    ;}\n\t.st21{fill:url(#Path_17_Copy-2_1_);}\n\t.st22{clip-path:url(#SVGID_6_);}\n\t.st23{opacity:0.2;fill:#617FC8;enable-background:new    ;}\n\t.st24{fill:url(#sleeve_1_);}\n\t.st25{fill:url(#arm_1_);}\n\t.st26{fill:url(#Path_7-2_1_);}\n\t.st27{clip-path:url(#SVGID_8_);}\n\t.st28{opacity:0.3;fill:url(#Path_1_);enable-background:new    ;}\n\t.st29{fill:url(#Path_4-2_1_);}\n\t.st30{clip-path:url(#SVGID_10_);}\n\t.st31{opacity:0.2;fill:#7890CB;enable-background:new    ;}\n\t.st32{fill:#FFFFFF;}\n\t.st33{fill:url(#Path_9-3_1_);}\n\t.st34{clip-path:url(#SVGID_12_);}\n\t.st35{opacity:0.6;stroke:#D9E8FF;stroke-width:4;stroke-miterlimit:10;enable-background:new    ;}\n\t.st36{opacity:0.3;fill:#CCDFFD;enable-background:new    ;}\n\t.st37{fill:url(#leg-3_1_);}\n\t.st38{fill:url(#face_1_);}\n\t.st39{fill:url(#Path_13-2_1_);}\n\t.st40{clip-path:url(#SVGID_14_);}\n\t.st41{opacity:0.5;fill:#6B84C2;enable-background:new    ;}\n\t.st42{fill:url(#hair_1_);}\n\t.st43{fill:#CCDFFD;}\n\t.st44{fill:url(#colar-2_1_);}\n\t.st45{fill:url(#sleeve-2_1_);}\n\t.st46{fill:#143B8C;}\n\t.st47{stroke:#143B8C;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st48{fill:none;stroke:#143B8C;stroke-width:4;stroke-miterlimit:10;}\n\t.st49{fill:none;}\n\t.st50{clip-path:url(#SVGID_16_);}\n\t.st51{fill:#EEF5FF;}\n\t.st52{fill:url(#pocket_1_);}\n\t.st53{opacity:0.2;fill:#BBCFF2;enable-background:new    ;}\n\t.st54{fill:url(#Ellipse_2-3_1_);}\n\t.st55{fill:url(#Ellipse_1-3_1_);}\n\t.st56{fill:url(#Shape_2-5_1_);}\n\t.st57{clip-path:url(#SVGID_18_);}\n\t.st58{opacity:0.5;stroke:#489C71;stroke-width:3;stroke-miterlimit:10;enable-background:new    ;}\n\t.st59{fill:url(#Shape_2-8_1_);}\n\t.st60{clip-path:url(#SVGID_20_);}\n\t.st61{fill:url(#Shape_2-11_1_);}\n\t.st62{clip-path:url(#SVGID_22_);}\n\t.st63{opacity:0.6;}\n\t.st64{fill:url(#Ellipse_4-3_1_);}\n\t.st65{fill:none;stroke:#FFFFFF;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 452.5167,
    y1: 591.4684,
    x2: 452.7737,
    y2: 592.5524,
    gradientTransform: "matrix(1416.0532 0 0 -865.1645 -640168.9375 512560.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ECF2FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B9CFF7"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "background",
    className: "st0",
    d: "M585.4,770.2c-246.6,31.2-463.2-59.9-511.8-228.9c-56.6-196.9,136-425.1,430.3-509.7 c236.4-67.9,466.5-22.5,577.2,100.1c190.3,0.7,348.4,86,388.9,226.9c53.8,187.2-120.4,401.5-389.2,478.8 c-65.7,18.9-130.9,27.8-192.8,27.8C766.9,865.2,658.8,831,585.4,770.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_3_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 447.1451,
    y1: 596.1429,
    x2: 447.6921,
    y2: 595.2458,
    gradientTransform: "matrix(102 0 0 -99 -44369.3906 59264.8516)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ACD6FF",
      stopOpacity: 0.153
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#96ACCB",
      stopOpacity: 0.459
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "_3",
    className: "st1",
    d: "M1247,242h63.9c4.2,0,7.6,3.4,7.6,7.6l-22.8,83.8c0,4.2-3.4,7.6-7.6,7.6h-63.9c-4.2,0-7.6-3.4-7.6-7.6 l22.8-83.8C1239.4,245.4,1242.8,242,1247,242z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_2_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 448.4843,
    y1: 595.1336,
    x2: 449.0313,
    y2: 594.2366,
    gradientTransform: "matrix(134 0 0 -130 -58763.3047 77651.5625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ACD6FF",
      stopOpacity: 0.153
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#96ACCB",
      stopOpacity: 0.459
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "_2",
    className: "st2",
    d: "M1343.5,278h84c5.5,0,10,4.5,10,10l-30,110c0,5.5-4.5,10-10,10h-84c-5.5,0-10-4.5-10-10l30-110 C1333.5,282.4,1338,278,1343.5,278z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 448.4843,
    y1: 595.1336,
    x2: 449.0313,
    y2: 594.2366,
    gradientTransform: "matrix(134 0 0 -130 -58844.3047 77738.5625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ACD6FF",
      stopOpacity: 0.153
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#96ACCB",
      stopOpacity: 0.459
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "_1",
    className: "st3",
    d: "M1262.5,365h84c5.5,0,10,4.5,10,10l-30,110c0,5.5-4.5,10-10,10h-84c-5.5,0-10-4.5-10-10l30-110 C1252.5,369.4,1257,365,1262.5,365z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "laptop",
    transform: "translate(1297 432)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "table",
    transform: "translate(130 167)",
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3-2",
    className: "st5",
    d: "M-118.5,0.9h21V273h-21V0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy-2",
    className: "st5",
    d: "M-188.5,273h161v21h-161V273z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2-2",
    className: "st5",
    d: "M-247.5-20h280V1h-280V-20z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "front",
    className: "st6",
    d: "M-34.5,147L-5.1,2l169.6,3l-29,142H-34.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "bottom",
    className: "st6",
    d: "M-117.5,138.8h264v9.2h-256L-117.5,138.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "back",
    transform: "translate(94)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Shape_9-2_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -940.4289,
    y1: 161.8142,
    x2: -940.9939,
    y2: 162.4972,
    gradientTransform: "matrix(199 0 0 -146 187209.3281 23774.9023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#367ED7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#153D8E"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_9-2",
    className: "st7",
    d: "M-118.5,148L-89.1,2L80.5,5l-28,143H-118.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "-118.5,148 -89.1,2 80.5,5 52.5,148  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "back-2",
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_5",
    className: "st9",
    d: "M-17.5,61c8.3,0,15,5.6,15,12.5S-9.2,86-17.5,86s-15-5.6-15-12.5S-25.8,61-17.5,61z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "message",
    transform: "translate(118 179)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "line",
    className: "st10",
    d: "M-33.5,4C-278,260.9,81.4,624.2,299.4,351.3C666.7-108.6,979.5,237,979.5,237"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rocket",
    transform: "translate(1079 212)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Shape_5_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -749.0632,
    y1: 204.127,
    x2: -748.0012,
    y2: 204.275,
    gradientTransform: "matrix(124.988 0 0 -111 93503.5313 22726.3535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDAE6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FAE539"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_5",
    className: "st11",
    d: "M-118.5,69l20.8-27.2L-30.1,84l-51.7-59.4L-56.7,1L6.5,112L-118.5,69z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_6",
    className: "st12",
    d: "M-98.3,42.5l15.8-2.1l55.3,45.8L-98.3,42.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_7",
    className: "st13",
    d: "M-83.3,40.3l2.2-15.8l52.4,60.2L-83.3,40.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Person",
    transform: "translate(174 196)"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "chair_shadow_1_",
    cx: 277.6436,
    cy: 400.8597,
    r: 0.853,
    gradientTransform: "matrix(413 0 0 -83 -114388.7891 33903.5156)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2062E7"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "chair_shadow",
    className: "st14",
    d: "M278,703c114,0,206.5-18.6,206.5-41.5c0-22.9-92.5-41.5-206.5-41.5S71.5,638.5,71.5,661.5 C71.5,684.4,164,703,278,703z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "chair_1_",
    cx: 277.9632,
    cy: 396.2731,
    r: 0.414,
    gradientTransform: "matrix(579.8652 0 0 -544.4641 -160972.1875 216130.1875)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#62ABFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1440C0"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "chair",
    className: "st15",
    d: "M135.1,635.7c126.5,60.7,312.4,52.7,395.7-112.1c55.1-106-62.4-232.9-191.5-321.2 c-115.8-79.2-218.8-97.2-279.3-52.6c-6.9,5.1-19.2,4.1-24.7,11C-118.1,336.1,8.6,575,135.1,635.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cushion_1_",
    cx: 277.9588,
    cy: 396.6338,
    r: 0.533,
    gradientTransform: "matrix(520.54 0 0 -435.894 -144388.5 173132.75)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4F8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#89B1E9"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "cushion",
    className: "st16",
    d: "M213.3,484.1c135.3,84.6,275.1,93.8,322.1,18.6c43.6-81.3-62.2-228.2-197.5-312.8 s-253.2-98-300.2-22.8S77.9,399.5,213.3,484.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "shadow",
    className: "st17",
    d: "M243.9,424.7c60.7,37.9,123.3,42.1,144.4,8.3c19.6-36.5-27.9-102.4-88.6-140.3 s-113.5-44-134.6-10.2S183.2,386.8,243.9,424.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shoe",
    transform: "translate(747 624)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_17-2_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -471.7307,
    y1: -222.0054,
    x2: -472.0127,
    y2: -222.9894,
    gradientTransform: "matrix(147.7569 0 0 -67.1869 69675.3906 -14898.4463)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9ABFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5B87D2"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17-2",
    className: "st18",
    d: "M-113.2,48.1c-2-9-5-15.7-2-27.9S-78,1.2-73.7,5s3.6,6,20.7,15.1s66.2,19.7,76.6,31.4 s12.5,19.6-9.4,19.6h-67.5c-12.1-4.4-16.2-6.8-23-10.8c-0.8,3.1-0.8,6.3,0,9.4h-29.1C-105.2,69.8-111.3,57.1-113.2,48.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M-113.2,48.1c-2-9-5-15.7-2-27.9S-78,1.2-73.7,5s3.6,6,20.7,15.1s66.2,19.7,76.6,31.4s12.5,19.6-9.4,19.6 h-67.5c-12.1-4.4-16.2-6.8-23-10.8c-0.8,3.1-0.8,6.3,0,9.4h-29.1C-105.2,69.8-111.3,57.1-113.2,48.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "shoe-2",
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    className: "st20",
    d: "M-113.2,62.9c6.3-16.1,30.7-46.2,37.7-56s-46.8,11.5-46.8,11.5S-119.4,79.1-113.2,62.9z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "shoe-3",
    transform: "translate(788 347)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_17_Copy-2_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -513.1573,
    y1: 53.6721,
    x2: -513.3232,
    y2: 52.6721,
    gradientTransform: "matrix(134.9466 0 0 -88.7267 69208.9531 4767.1743)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#91BAFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5B87D2"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17_Copy-2",
    className: "st21",
    d: "M-97.3,80.2c-6.4-6.1-12.4-9.8-16.6-21s19.2-35.2,24.8-34.4s6.1,2.8,24.6,0.8 S-13,1,1.7,4.7s27.9,3.8,10.6,15.5C4.1,25.7-27.4,59.4-37.2,66c-12,3-16.5,3.4-24.1,3.8c1,2.9,2.8,5.5,5.1,7.5L-79.3,93 C-79.3,93-90.9,86.2-97.3,80.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M-97.3,80.2c-6.4-6.1-12.4-9.8-16.6-21s19.2-35.2,24.8-34.4s6.1,2.8,24.6,0.8S-13,1,1.7,4.7 s27.9,3.8,10.6,15.5C4.1,25.7-27.4,59.4-37.2,66c-12,3-16.5,3.4-24.1,3.8c1,2.9,2.8,5.5,5.1,7.5L-79.3,93 C-79.3,93-90.9,86.2-97.3,80.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "shoe-4",
    className: "st22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    className: "st23",
    d: "M-87.8,90.6c-9.7-20.1,0.3-65.4-4.1-69.4c-4.4-4-26,32.4-26,32.4s-10.3,10.2,6.2,25.4 S-78.1,110.7-87.8,90.6z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sleeve_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.1661,
    y1: 398.0813,
    x2: 273.8691,
    y2: 397.4443,
    gradientTransform: "matrix(113.9423 0 0 -191.8499 -30892.9746 76469.0781)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5F8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "sleeve",
    className: "st24",
    d: "M271.7,204.5c44.9-23.9,70.6-93.8,89.1-113.4c18.6-19.6,26.8,17.9,23.7,29s-25.7,85.4-72.9,145.5 C311.6,304.8,265.9,236,271.7,204.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "arm_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 273.987,
    y1: 400.3635,
    x2: 274.611,
    y2: 401.3635,
    gradientTransform: "matrix(123.8486 0 0 -76.8392 -33670.8711 30929.8945)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B86C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A1B8E3"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "arm",
    className: "st25",
    d: "M252.5,125.2c0,0,106.5-42.1,120.9-39.3s-28.6,51.9-37.4,55.8c-8.8,4-20.8,13.6-34,14 s-43.7,6.9-43.7,6.9L252.5,125.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "leg",
    transform: "translate(384 346)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_7-2_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -106.3837,
    y1: 50.8275,
    x2: -106.0227,
    y2: 51.0975,
    gradientTransform: "matrix(402.2747 0 0 -288.6164 42887.2695 14851.1914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#002383"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#316EEA"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7-2",
    className: "st26",
    d: "M-105.2,95C-92.1,77.3-60.1,40.5,8.9,27.1s132.3-25.9,248.6,8.6 c9.6,112.3,20.5,225.3,31.5,248.2c-8.4,10.2-38.7,18-56.5,18c-6.5-25.3-26.7-86.2-37-116.3s-13.9-67.5-11.9-80.7 c-35,10-106.8,40.2-132,49.2s-111.5,37.4-140.1,14.5S-118.3,112.6-105.2,95z"
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M-105.2,95C-92.1,77.3-60.1,40.5,8.9,27.1s132.3-25.9,248.6,8.6c9.6,112.3,20.5,225.3,31.5,248.2 c-8.4,10.2-38.7,18-56.5,18c-6.5-25.3-26.7-86.2-37-116.3s-13.9-67.5-11.9-80.7c-35,10-106.8,40.2-132,49.2 s-111.5,37.4-140.1,14.5S-118.3,112.6-105.2,95z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "leg-2",
    className: "st27"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -110.6405,
    y1: 52.2224,
    x2: -110.1405,
    y2: 52.8314,
    gradientTransform: "matrix(105.2737 0 0 -136.4659 11755.0957 7247.4194)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#002343"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A72FF",
      stopOpacity: 0.435
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st28",
    d: "M132.6,125.4c0-15.6,39.6-98.2,50.2-107.1c10.6-8.8-20.9-7.5-20.9-7.5S90.1,85.4,80.7,125.4 S132.6,141.1,132.6,125.4z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "neck",
    transform: "translate(298 152)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_4-2_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -26.0437,
    y1: 246.9685,
    x2: -26.0437,
    y2: 246.3665,
    gradientTransform: "matrix(80.8784 0 0 -132.0092 2029.7648 32630.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6081C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#90AADB"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4-2",
    className: "st29",
    d: "M-105.5,62.1C-109,44.7-115.7,14.2-117,7.7c-1.3-6.5,63.4,16,63.4,16l8.1,42.7l9.3,72.2 C-36.2,138.5-102.1,79.5-105.5,62.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "M-105.5,62.1C-109,44.7-115.7,14.2-117,7.7c-1.3-6.5,63.4,16,63.4,16l8.1,42.7l9.3,72.2 C-36.2,138.5-102.1,79.5-105.5,62.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "neck-2",
    className: "st30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    className: "st31",
    d: "M-113.5,9.5c0,6.6,24.6,34.6,37.8,42.2s37.2,7,37.2,7L-42.1,21l-71.4-18V9.5z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "shirt",
    transform: "translate(245 198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_9"
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9-2",
    className: "st32",
    d: "M3.9,1.3c0,0,24.6,4,26.3,7.1c16,11.6,31.4,46.2,37.9,64.1s19.2,36.4,30.5,50.8 s16.8,17.3,31.7,28s20.3,19.1,11.9,27s-56.9,4.8-91.4,48c-30.1,12.4-30.1,16.9-39.1-9.8s-82.6-93.5-94.5-102.9 s-7.3-18.5-10.3-47.3c-3-28.8-24.7-52.2-6.5-52.2c14.4,5.4,28.4-5.6,34.7-5.6c23.1,5.7,28.3,28.4,37.9,23.7s15.7-4.8,15.7-4.8 c2.2,4.5,3,12.3,5.2,16.8s11.6,13.6,15.7,22L2.3,41.6l2-14.7L3.9,1.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_9-3_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.9279,
    y1: 198.8428,
    x2: 31.8369,
    y2: 199.0768,
    gradientTransform: "matrix(252.9848 0 0 -234.6268 -8017.0376 46866.625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B1C2E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9-3",
    className: "st33",
    d: "M3.9,1.3c0,0,24.6,4,26.3,7.1c16,11.6,31.4,46.2,37.9,64.1s19.2,36.4,30.5,50.8 s16.8,17.3,31.7,28s20.3,19.1,11.9,27s-56.9,4.8-91.4,48c-30.1,12.4-30.1,16.9-39.1-9.8s-82.6-93.5-94.5-102.9 s-7.3-18.5-10.3-47.3c-3-28.8-24.7-52.2-6.5-52.2c14.4,5.4,28.4-5.6,34.7-5.6c23.1,5.7,28.3,28.4,37.9,23.7s15.7-4.8,15.7-4.8 c2.2,4.5,3,12.3,5.2,16.8s11.6,13.6,15.7,22L2.3,41.6l2-14.7L3.9,1.3z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_11_",
    d: "M11.8,216.3c-9-26.7-82.6-93.5-94.5-102.9s-7.3-18.5-10.3-47.3c-2.1-20.5-13.7-38.2-13.7-46.7 c0-3.5,1.9-5.5,7.2-5.5c14.4,5.4,28.4-5.6,34.7-5.6c23.1,5.7,28.3,28.4,37.9,23.7s15.7-4.8,15.7-4.8c2.2,4.5,3,12.3,5.2,16.8 s11.6,13.6,15.7,22L2.3,41.6l2-14.7L3.9,1.3c0,0,24.6,4,26.3,7.1c16,11.6,31.4,46.2,37.9,64.1s19.2,36.4,30.5,50.8 s16.8,17.3,31.7,28c10.1,7.2,15.9,13.4,15.9,19.2c0,2.7-1.3,5.3-4,7.8c-8.4,7.9-56.9,4.8-91.4,48c-14,5.7-21.5,9.8-26.4,9.8 C18.8,235.9,16.6,230.5,11.8,216.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "shirt-2",
    className: "st34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_1",
    className: "st35",
    d: "M5.5,66c2.2,4.4,25.9,46,31,52c5.1,6,21.6,22.7,28,29s45.5,31.2,46,39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    className: "st36",
    d: "M-24.6,58.1c0,0,10.9-19.8,17.3-19.8S-9.5,19-9.5,19l-19.8,15L-24.6,58.1z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "leg-3_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.4087,
    y1: 397.575,
    x2: 277.5797,
    y2: 397.19,
    gradientTransform: "matrix(405.4061 0 0 -241.4497 -112045.0781 96280.8438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3D9BF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B80F0"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "leg-3",
    className: "st37",
    d: "M384.5,365.2c36.2-33.3,139.9-97.6,199-107.4c33.9,5.6,122,101.2,122,101.2 c-4,4.2-14.5,41.3-31,53c-41.7-34.6-85.1-50.8-96.8-68.6c-14.6,8.9-52,34.7-73.5,72.7s-35.8,81.3-60.3,82.4s-59.1,3.9-91-16.6 c-18.5-11.9-71.8-38.4-45.9-55.8C321.9,416.1,369.3,379.2,384.5,365.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "face_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.3646,
    y1: 399.5099,
    x2: 273.6476,
    y2: 399.133,
    gradientTransform: "matrix(107.9349 0 0 -110.546 -29329.5527 44275.7656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701,
    style: {
      stopColor: "#B8CBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A1B8E3"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "face",
    className: "st38",
    d: "M243.3,87.7c2.5,6.2,15.9,33.4,17.2,40.1c1.3,6.8,14.1,52,6.5,58.9c-7.6,7-30.5,10.5-36.9,8.3 c-6.4-2.2-20.1-3.7-25.5-13.1c-4.1-7.2-17.2-24-20.6-23c-1.3,2.6-5.6,5.3-7.8,3.6c-9.4-7.6-17.6-15.9-13.7-34.6s17.3-28,31.8-34.1 C208.6,87.7,240.8,81.5,243.3,87.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arm-2",
    transform: "translate(134 139)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_13-2_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.2484,
    y1: 264.3193,
    x2: 141.3764,
    y2: 265.3193,
    gradientTransform: "matrix(154.4236 0 0 -50.2403 -21858.6074 13332.2148)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7992C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A1B8E3"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13-2",
    className: "st39",
    d: "M-56,52.6c17.5,7.1,74.2-21.1,92.2-18.6c16.5,2.3-4.4-23.6-10.7-28.1s-130.4-2.5-136.9,7 C-117.9,22.5-70.5,46.7-56,52.6z"
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    d: "M-56,52.6c17.5,7.1,74.2-21.1,92.2-18.6c16.5,2.3-4.4-23.6-10.7-28.1s-130.4-2.5-136.9,7 C-117.9,22.5-70.5,46.7-56,52.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "arm-3",
    className: "st40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    className: "st41",
    d: "M-90.5,13.8c3.7,1.3,78.4,33.9,96.8,29.4s-46,17-46,17S-94.1,12.5-90.5,13.8z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hair_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 275.157,
    y1: 397.9413,
    x2: 274.196,
    y2: 397.6333,
    gradientTransform: "matrix(126.8992 0 0 -183.235 -34629.2305 72981.125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2669E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#143B8C"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "hair",
    className: "st42",
    d: "M191.5,127.9c0,0-8.5-12.8-1.9-25.6c6.5-12.7,41,4.3,69-27.1s3.1-73.8-25.6-65.5 s-21.7,23.1-16.5,34.1s-21.6,15.2-40.7,23s-34.8,28.7-31.4,61.2s33.5,59.1,43.1,64c-2.8-19.2-2.9-28-2.9-33.4 c-11,5.1-23.8-20.1-16.4-26.7c14.2-12.7,21.4,16.2,21.4,16.2c1.4-2.9,3.2-5.6,5.3-8C194.1,135.9,193,131.8,191.5,127.9z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "colar",
    className: "st43",
    d: "M249.5,224.3c8.7,3.1,10.4,19.3,11.9,23.8c1.5,4.6-6.3-35.7-6.3-35.7c-2.7,3.8-8.6-21.9-7.5-18.2 C250.6,204.4,248.1,215.8,249.5,224.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "colar-2_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 268.0882,
    y1: 400.6691,
    x2: 268.3492,
    y2: 400.9061,
    gradientTransform: "matrix(53.297 0 0 -78.408 -14092.3428 31651.8613)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEF5FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ADC8F2"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "colar-2",
    className: "st44",
    d: "M221,265c0-14.3,5.7-33.1,12.7-39.8c-10.2,0.6-40.1-17.3-43.3-27.2c-3.2-10-3.8-11.4-3.8-11.4 s-6.2,11.9-6.2,19.5C184.8,222.5,204.2,251,221,265z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sleeve-2_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 275.5238,
    y1: 398.5002,
    x2: 275.2268,
    y2: 397.8632,
    gradientTransform: "matrix(154.8479 0 0 -160.0736 -42540.2773 63950.5742)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5F8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "sleeve-2",
    className: "st45",
    d: "M133.4,208c-29.6-16.3-88.7-62.5-104.2-58.7s-11.5,10.8-11.5,26.9s81.2,70.4,93.7,97.2 c5.3,11.5,19.1,39.9,43.6,35.3c24.5-4.6,17.1-29,11.8-48.7C160.6,236.9,151.7,218,133.4,208z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M260.6,150.3c-1.1-0.2-1.6,0.8-2.3,1.7c-2.2,3.1-6.9,6.5-9.7,7.1c-0.1,0-0.2,0-0.4,0.1l0,0c0,0,0,0-0.1,0 c-2.3,1.7-8.1,2.9-11.9,2.4c-1.1-0.1-2.2-0.4-2.8,0.5c-0.6,0.9,0.5,2.2,1.5,2.6c5,1.9,12.3,3.3,16,0.6c4.5-0.9,8.5-7.2,10.6-12.2 C261.9,152.1,261.7,150.4,260.6,150.3z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "glasses",
    transform: "translate(301 97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    className: "st47",
    d: "M-88,31.5c5.2,1.4,11.6,0.4,15.1-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18_Copy",
    className: "st47",
    d: "M-46.5,20.5c4.5,1.4,10.1,0.4,13-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    className: "st48",
    d: "M-99.5,23.4l5.6,24.6l31-7.4L-67.6,15L-99.5,23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14_Copy",
    className: "st48",
    d: "M-54.2,10.9l5,25.1l23.2-6.7l-4.2-25.1L-54.2,10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    className: "st46",
    d: "M-100.1,26.5l-18.3,5l3.1,6.1l19.7,4.7L-100.1,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    className: "st46",
    d: "M-66.6,22.7l13.9-4.3l1.5,7.4l-14.5,4L-66.6,22.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Oval_3_Oval_3_Copy_Oval_3_Copy_2_Oval_3_Copy_4_Oval_3_Copy_3_Mask"
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Mask-2",
    className: "st49",
    d: "M213.3,484.1c135.3,84.6,275.1,93.8,322.1,18.6C591.8,393,398.3,440.5,263,355.9 S131,200.7,37.6,167.1C-9.4,242.3,77.9,399.5,213.3,484.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_15_",
    d: "M213.3,484.1c135.3,84.6,275.1,93.8,322.1,18.6C591.8,393,398.3,440.5,263,355.9S131,200.7,37.6,167.1 C-9.4,242.3,77.9,399.5,213.3,484.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Oval_3_Oval_3_Copy_Oval_3_Copy_2_Oval_3_Copy_4_Oval_3_Copy_3_Mask-2",
    className: "st50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval_3",
    className: "st51",
    d: "M-28.8,377.3c70.6,45.9,151.6,46.6,180.7,1.7s-4.4-118.5-75.1-164.4s-151.6-46.6-180.7-1.7 S-99.4,331.4-28.8,377.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_3_Copy",
    className: "st51",
    d: "M219,560.1c52.1-24.3,68.2-99.7,36.1-168.6s-100.3-104.9-152.4-80.7 s-68.2,99.7-36.1,168.6S166.9,584.4,219,560.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_3_Copy_2",
    className: "st51",
    d: "M354,676.1c52.1-24.3,68.2-99.7,36.1-168.6s-100.3-104.9-152.4-80.7 s-68.2,99.7-36.1,168.6S301.9,700.4,354,676.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_3_Copy_4",
    className: "st51",
    d: "M606,715.1c52.1-24.3,68.2-99.7,36.1-168.6c-32.1-68.8-100.3-104.9-152.4-80.7 s-68.2,99.7-36.1,168.6S553.9,739.4,606,715.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_3_Copy_3",
    className: "st51",
    d: "M427.7,638.9c57,7,107.6-22.7,112.9-66.2c5.4-43.6-36.5-84.6-93.5-91.6 s-107.6,22.7-112.9,66.2C328.8,590.9,370.7,631.9,427.7,638.9z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pocket_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.5551,
    y1: 405.8198,
    x2: 266.3001,
    y2: 404.8198,
    gradientTransform: "matrix(45.375 0 0 -42.6243 -11795.3994 17558.1113)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEF5FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D9E8FF"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "pocket",
    className: "st52",
    d: "M270.8,269.5c0,0,23.7-4.5,26.5-7.7c2.8-3.2,18.9,33.6,18.9,33.6l-7.8,8.8h-18.6L270.8,269.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Plant",
    transform: "translate(178 613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pot",
    transform: "translate(41 181)"
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "shadow-2",
    className: "st53",
    d: "M-46.5,75c39.8,0,72,6.9,72,15.5S-6.7,106-46.5,106s-72-6.9-72-15.5S-86.2,75-46.5,75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2-2",
    transform: "translate(2 11)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ellipse_2-3_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.6784,
    y1: -209.1042,
    x2: 227.9574,
    y2: -208.6042,
    gradientTransform: "matrix(144 0 0 -88 -32886.5938 -18326.6914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CEE0FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4EDFB"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_2-3",
    className: "st54",
    d: "M18.5,3.3c4.6,7.9,7,17,7,26.1c0,33.4-32.2,60.5-72,60.5s-72-27.1-72-60.5 c0-9.7,2.7-19.2,7.9-27.5C-78.7,7-15.2,6.7,18.5,3.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1-2",
    transform: "translate(8)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ellipse_1-3_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 221.6622,
    y1: -188.5253,
    x2: 221.6622,
    y2: -189.5253,
    gradientTransform: "matrix(131 0 0 -31 -29089.7207 -5843.3271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#99BAE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BCD0F2"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1-3",
    className: "st55",
    d: "M-52,1c36.2,0,65.5,6.9,65.5,15.5S-15.8,32-52,32s-65.5-6.9-65.5-15.5S-88.1,1-52,1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "leaves"
  }, /*#__PURE__*/React.createElement("g", {
    id: "leaves-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "leaf",
    transform: "translate(47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape_2-4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Shape_2-5_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.474,
    y1: -18.7845,
    x2: 220.918,
    y2: -19.7345,
    gradientTransform: "matrix(76.9467 0 0 -183 -17054.0566 -3430.6323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B1FFBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    style: {
      stopColor: "#5CDB8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#149654"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_2-5",
    className: "st56",
    d: "M-55.5,184c-3.6-24.8-13.4-60.5-43-99C-115.9,62.3-116,7-118.5,1 c13.7,4.7,38.2,16.8,63,51C-29.5,87.8-46,160.8-55.5,184z"
  })), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_17_",
    d: "M-55.5,184c-3.6-24.8-13.4-60.5-43-99C-115.9,62.3-116,7-118.5,1c13.7,4.7,38.2,16.8,63,51 C-29.5,87.8-46,160.8-55.5,184z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Shape_2-6",
    className: "st57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    className: "st58",
    d: "M-56.5,184c2.7-60.2-4.8-98.1-28.3-134"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "leaf-2",
    transform: "translate(0 89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape_2-7"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Shape_2-8_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 269.7444,
    y1: -106.4604,
    x2: 269.8623,
    y2: -107.4414,
    gradientTransform: "matrix(109.591 0 0 -118.6618 -29631.8203 -12637.0186)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B1FFBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    style: {
      stopColor: "#5CDB8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#149654"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_2-8",
    className: "st59",
    d: "M-8.4,120.4c-11.1-17.7-30.6-41.6-66.1-61.1C-95.4,47.9-114,5.8-118,2 c12-1,34.8,0,65.2,17.7C-20.9,38.3-8.9,99.6-8.4,120.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_19_",
    d: "M-8.4,120.4c-11.1-17.7-30.6-41.6-66.1-61.1C-95.4,47.9-114,5.8-118,2c12-1,34.8,0,65.2,17.7 C-20.9,38.3-8.9,99.6-8.4,120.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Shape_2-9",
    className: "st60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_3-2",
    className: "st58",
    d: "M-9.1,120.7C-27.3,73.9-45.8,47.5-75.8,28"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "leaf-3",
    transform: "translate(115 78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape_2-10"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Shape_2-11_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 153.7638,
    y1: -95.9366,
    x2: 154.2078,
    y2: -96.8866,
    gradientTransform: "matrix(94.2947 0 0 -132.014 -14586.6279 -12654.0879)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B1FFBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    style: {
      stopColor: "#5CDB8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#149654"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_2-11",
    className: "st61",
    d: "M-115.4,133.8c8.7-19,25.1-45.4,57.9-69.3C-38.2,50.4-25.1,6.1-21.6,1.8 c-12.1,0.5-34.7,4.5-62.7,26.1C-113.6,50.5-117.6,113-115.4,133.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_21_",
    d: "M-115.4,133.8c8.7-19,25.1-45.4,57.9-69.3C-38.2,50.4-25.1,6.1-21.6,1.8 c-12.1,0.5-34.7,4.5-62.7,26.1C-113.6,50.5-117.6,113-115.4,133.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Shape_2-12",
    className: "st62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_3-3",
    className: "st58",
    d: "M-118,133.7c12-48.9,27-77.7,54.4-100.9"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Clock",
    transform: "translate(210 72)",
    className: "st63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4-2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ellipse_4-3_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.4923,
    y1: 522.9874,
    x2: 238.1983,
    y2: 522.4124,
    gradientTransform: "matrix(124 0 0 -124 -29619.0195 64894.8164)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBDAF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9CB3DF"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_4-3",
    className: "st64",
    d: "M-55.5,1c34.2,0,62,27.8,62,62s-27.8,62-62,62s-62-27.8-62-62S-89.7,1-55.5,1z"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_8",
    className: "st65",
    d: "M-54.7,20.6v44.6l20.4,20.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelaxingMan);
export default __webpack_public_path__ + "static/media/relaxing-man.a158481294da4e6721dbaeaef0530d02.svg";
export { ForwardRef as ReactComponent };